module.exports = __webpack_public_path__ + "static/media/invoice_number_period_help_v2.755fdd6a.png";